import styled from 'styled-components'

export const BodyWrapper = styled.div`
  max-width: 1200px;
  height: 100%;
  min-height: 600px;
  margin: auto;
  margin-bottom: 25px;
`;